import React from 'react'

const Contact = () => {
  return (
    <>
    <div className='container my-2 py-3' >
                <div className='row'>
                    <div className='col-12 mb-1'>
                        <div><h1 className='fw-bolder text-center mt-1'> Contact Us </h1><hr /></div>
                    </div>
                </div>
                </div>
<footer class="text-center text-lg-start bg-light text-muted">
 
 <section class="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">

   <div class="me-5 d-none d-lg-block">
     <span>{`Get connected with us on social networks:(Dummy footer)`}</span>
   </div>
   <div>
     <a href="" class="me-4 text-reset">
       <i class="fab fa-facebook-f"></i>
     </a>
     <a href="" class="me-4 text-reset">
       <i class="fab fa-twitter"></i>
     </a>
     <a href="" class="me-4 text-reset">
       <i class="fab fa-google"></i>
     </a>
     <a href="" class="me-4 text-reset">
       <i class="fab fa-instagram"></i>
     </a>
     <a href="" class="me-4 text-reset">
       <i class="fab fa-linkedin"></i>
     </a>
     <a href="" class="me-4 text-reset">
       <i class="fab fa-github"></i>
     </a>
   </div>
 
 </section>


 <section class="">
   <div class="container text-center text-md-start mt-5">
     <div class="row mt-3">
       <div class="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
         <h6 class="text-uppercase fw-bold mb-4">
           <i class="fas fa-gem me-3"></i>React Collections
         </h6>
         <p>
         Whoever said money can’t buy happiness clearly didn’t know where to shop!
         </p>
       </div>

       <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
         <h6 class="text-uppercase fw-bold mb-4">
           Products
         </h6>
         <p>
           <a href="#!" class="text-reset">Angular</a>
         </p>
         <p>
           <a href="#!" class="text-reset">React</a>
         </p>
         <p>
           <a href="#!" class="text-reset">Vue</a>
         </p>
         <p>
           <a href="#!" class="text-reset">Laravel</a>
         </p>
       </div>

       <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
         <h6 class="text-uppercase fw-bold mb-4">
           Useful links
         </h6>
         <p>
           <a href="#!" class="text-reset">Pricing</a>
         </p>
         <p>
           <a href="#!" class="text-reset">Settings</a>
         </p>
         <p>
           <a href="#!" class="text-reset">Orders</a>
         </p>
         <p>
           <a href="#!" class="text-reset">Help</a>
         </p>
       </div>
     
 
       <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
      
         <h6 class="text-uppercase fw-bold mb-4">Contact</h6>
         <p><i class="fas fa-home me-3"></i> New York, NY 10012, US</p>
         <p>
           <i class="fas fa-envelope me-3"></i>
          poornachary1@gmail.com
         </p>
         <p><i class="fas fa-phone me-3"></i> + 01 234 567 88</p>
         <p><i class="fas fa-print me-3"></i> + 01 234 567 89</p>
       </div>
      
     </div>
     
   </div>
 </section>



 <div class="text-center p-4" style={{backgroundColor:"lightblue"}}>
  Made with ❤️ on React, Redux © 2021 Copyright:
   <a class=" text-reset fw-bold " >Poorna chary </a>
 </div>

</footer>
    </>
  )
}

export default Contact